import React, { Component } from "react";
import PropTypes from "prop-types";
import WebConfig from "middlewares/WebConfig";

class LegacyCaseView extends Component {
  constructor(props) {
    super(props);
    this.frameRef = React.createRef();
    this.onMessage = this.onMessage.bind(this);
    this.postToFrame = this.postToFrame.bind(this);
    this.saveData = this.saveData.bind(this);
    this.validate = this.validate.bind(this);
    this.refreshFrame = this.refreshFrame.bind(this);
    this.state = {
      frameKey: 0
    };
  }

  componentDidMount() {
    window.addEventListener("message", this.onMessage);
    this.props.qaView.current = {};
    this.props.qaView.current.saveData = this.saveData;
    this.props.qaView.current.validate = this.validate;
    this.props.qaView.current.refreshFrame = this.refreshFrame;
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.onMessage);
  }

  saveData(onCompleted) {
    this.postToFrame("save", "");
    this.onSaveCompleted = onCompleted;
  }

  validate(onCompleted) {
    this.postToFrame("validate", "");
    this.onValidateCompleted = onCompleted;
  }

  refreshFrame() {
    this.setState({ frameKey: this.state.frameKey + 1 });
  }

  postToFrame(type, message) {
    this.frameRef.current.contentWindow.postMessage(
      JSON.stringify({
        application: "mueller-enterprise",
        type: type,
        message: message
      }),
      "*"
    );
  }

  onMessage(event) {
    if (event.origin !== WebConfig.orthosRoot) return;
    if (event.data?.source) return;

    let obj = JSON.parse(event.data);

    if (obj.application !== "mueller-enterprise") return;

    switch (obj.type) {
      case "onInitLoad":
        this.props.onLoadFinished();
        break;
      case "onSaveStarted":
        break;
      case "onSaveSuccess":
        this.onSaveCompleted();
        break;
      case "onSaveError":
        if (obj.message) {
          alert(obj.message);
        } else {
          alert("There was an error saving the case.");
        }
        this.onSaveCompleted();
        break;
      case "onValidateCompleted":
        if (this.onValidateCompleted) {
          this.onValidateCompleted(obj.message);
          this.onValidateCompleted = null;
        }
        break;
    }
  }

  render() {
    const { hidden, src } = this.props;
    return (
      <iframe
        id="legacy_view_frame"
        ref={this.frameRef}
        style={{ display: hidden ? "none" : "flex" }}
        key={this.state.frameKey}
        className="legacy-frame"
        src={`${WebConfig.orthosRoot}${src}`}
      />
    );
  }
}

LegacyCaseView.propTypes = {
  onLoadFinished: PropTypes.func.isRequired,
  hidden: PropTypes.bool.isRequired,
  src: PropTypes.string.isRequired,
  qaView: PropTypes.object,
};
export default LegacyCaseView;
